import React from "react";
import { useLocalization } from "@i18n";
import { GeneralDashboardCard } from "./GeneralDashboardCard";
import { GeneralDashboardFieldGrid, FieldItem } from "./GeneralDashboardFieldGrid";
import { DAM_HYDROLOGY_FIELDS } from "../utils/generalFieldConfigs";

interface GeneralHydrologyCardProps {
  data: Record<string, unknown> | null;
}

export const GeneralHydrologyCard: React.FC<GeneralHydrologyCardProps> = ({ data }) => {
  const { translate } = useLocalization();

  const fields: FieldItem[] = DAM_HYDROLOGY_FIELDS.map((field) => {
    const rawValue = data ? data[field.name] : null;
    const value =
      field.name === "spillwayType" && rawValue
        ? translate(`admin.structures.hydrology.spillwayType.${String(rawValue)}`)
        : rawValue;

    return { labelKey: field.labelKey, value };
  });

  return (
    <GeneralDashboardCard
      title={translate("general.dashboard.hydrology.title")}
      titleVariant="large"
      className="general-dashboard-hydrology-card"
      padding="compact"
    >
      <GeneralDashboardFieldGrid fields={fields} variant="hydrology" />
    </GeneralDashboardCard>
  );
};
